import React from 'react';
import s from './InfoCheckbox.module.css';

type Props = {
	labelTxt: string;
	id: string;
	setFieldValue: any;
	values: any;
	valueName: string;
	insideOnChange?: any;
};
const NewInfoCheckbox = ({
	labelTxt,
	id,
	values,
	setFieldValue,
	valueName,
	insideOnChange,
}: Props) => {
	const handleChange = () => {
		setFieldValue(valueName, id);
		insideOnChange && insideOnChange(id);
	};
	return (
		<div className={s.checkBoxContainer}>
			<input
				className={s.checkboxInput}
				id={id}
				onChange={handleChange}
				type={'checkbox'}
				checked={values[valueName] === id}
			/>
			<label htmlFor={id}>{labelTxt}</label>
		</div>
	);
};

export default NewInfoCheckbox;
